import { appMethod as app } from '@utils/app';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './GoodsAlreadyRefunded.less';

export default class GoodsAlreadyRefunded extends OfficialPage {
  state = {
    alreadyGoods: []
  }

  constructor(props) {
    super(props);
    document.title = '已退商品';
  }

  componentWillMount() {
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getAlreadyGoods()
  }
  getAlreadyGoods = () => {
    let alreadyGoods = app.getCurrentPages()[app.getCurrentPages().length - 2]
      .data.orderInfo.goods_info
    let refundPrice = app.getCurrentPages()[app.getCurrentPages().length - 2]
      .data.orderInfo.refunded_price
    this.setData({
      alreadyGoods: alreadyGoods,
      refundPrice: refundPrice
    })
  }

  render() {
    const { alreadyGoods, refundPrice } = this.state
    return (
      <div className="official-page goods-already-refunded">
        <TopNav title="已退商品" />
        <div className="already-goods-box">
          {alreadyGoods.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.refunded_num > 0 && (
                  <div className="goods-detail-box">
                    <img src={item.cover} />
                    <div>
                      <div className="goods-name">
                        {item.is_group_buy_order &&
                          item.is_group_buy_order != 0 && (
                            <span className="is-seckill">拼团</span>
                          )}
                        {item.is_seckill == 1 && (
                          <span className="is-seckill">秒杀</span>
                        )}
                        {item.is_benefit_goods == 1 && (
                          <span className="is-seckill">赠品</span>
                        )}
                        {item.goods_name}
                      </div>
                      {item.model_value && (
                        <div className="goods-rules">{item.model_value}</div>
                      )}
                      <div className="goods-price">
                        <span className="colorff7">{'¥' + item.price}</span>
                        <span className="pull-right">
                          {'x ' + item.refunded_num}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
          })}
          <div className="already-price">
            退款金额
          <span className="pull-right colorff7">{'¥' + refundPrice}</span>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-already-refunded/GoodsAlreadyRefunded.jsx